/**
 * @author: bibek
 * @since: Wed Jul 05 2017 08:32:24 GMT+0530 (IST)
 * @file: environment.js
 *
 * @copyright: KNOLSKAPE Solutions Pvt Ltd
 **/

/**
 *
 * Exports styling related constants
 *
 **/

const actions = {
	RECEIVE_INIT_DATA: "RECEIVE_INIT_DATA",
	SET_TUTORIAL_STATUS: "SET_TUTORIAL_STATUS",
	SET_MAILS: "SET_MAILS",
	SET_END_TUTORIAL_POPUP_FLAG: "SET_END_TUTORIAL_POPUP_FLAG",
	RESTART_TUTORIAL: "RESTART_TUTORIAL",
	SET_MAIL_THREADS: "SET_MAIL_THREADS",
	GET_CURRENT_TIME: "GET_CURRENT_TIME",
	SET_GAME_OVER_FLAG: "SET_GAME_OVER_FLAG",
	GET_TOTAL_TIME: "GET_TOTAL_TIME",
	ADD_SHOW_MAIL_FLAG: "ADD_SHOW_MAIL_FLAG",
	UPDATE_INIT_TIME: "UPDATE_INIT_TIME",
	UPDATE_TIME_LEFT: "UPDATE_TIME_LEFT",
	GAME_COMPLETED: "GAME_COMPLETED",
	GET_NEXT_MAIL: "GET_NEXT_MAIL",
	VIEW_SENT_MAIL: "VIEW_SENT_MAIL",
	SET_MAIL_RECEIVED_AT_TIME: "SET_MAIL_RECEIVED_AT_TIME",
	SAVE_DRAFT: "SAVE_DRAFT",
	ADD_SHOW_CALL_FLAG: "ADD_SHOW_CALL_FLAG",
	ADD_SHOW_MEETING_FLAG: "ADD_SHOW_MEETING_FLAG",
	ADD_MAIL_READ_FLAG: "ADD_MAIL_READ_FLAG",
	ADD_MAIL_STARRED_FLAG: "ADD_MAIL_STARRED_FLAG",
	REMOVE_MAIL_STARRED_FLAG: "REMOVE_MAIL_STARRED_FLAG",
	SET_CURRENT_MAIL_INDEX: "SET_CURRENT_MAIL_INDEX",
	SAVE_SURVEY_ANSWER: "SAVE_SURVEY_ANSWER",
	SET_SURVEY_COMPLETED_FLAG: "SET_SURVEY_COMPLETED_FLAG",
	STORE_CURRENT_CALL_ID: "STORE_CURRENT_CALL_ID",
	STORE_CURRENT_MEETING_ID: "STORE_CURRENT_MEETING_ID",
	RECEIVE_REPORT_URL: "RECEIVE_REPORT_URL",
	ERROR: "ERROR",
	EMPTY_ERROR: "EMPTY_ERROR",
	UPDATE_GENERATING_USER_REPORT_FLAG: "UPDATE_GENERATING_USER_REPORT_FLAG",
	UPDATE_EMAIL_ADDRESS: "UPDATE_EMAIL_ADDRESS",
	START_CALL: "START_CALL",
	TERMINATE_CALL: "TERMINATE_CALL",
	INCOMING_CALL_NOTIFICATION: "INCOMING_CALL_NOTIFICATION",
	CALL_RECIEVED: "CALL_RECIEVED",
	END_CALL: "END_CALL",
	INCOMING_MEETING_NOTIFICATION: "INCOMING_MEETING_NOTIFICATION",
	COUNT_DOWN_TIMER: "COUNT_DOWN_TIMER",
	MEETING_RECIEVED: "MEETING_RECIEVED",
	END_MEETING: "END_MEETING",
	SHOW_MEETING_NOTIFICATION: "SHOW_MEETING_NOTIFICATION",
	HIDE_MEETING_NOTIFICATION: "HIDE_MEETING_NOTIFICATION",
	OPEN_HELP_MENU: "OPEN_HELP_MENU",
	CLOSE_HELP_MENU: "CLOSE_HELP_MENU",
	SET_SURVEY_SEQUENCE: "SET_SURVEY_SEQUENCE",

	START_TUTORIAL: "START_TUTORIAL",
	ADD_TUTORIAL_STEPS: "ADD_TUTORIAL_STEPS",
	UPDATE_TUTORIAL_STEP: "UPDATE_TUTORIAL_STEP",
	END_TUTORIAL: "END_TUTORIAL",
	STOP_TUTORIAL: "STOP_TUTORIAL",

	UPDATE_SELECTED_OPTION: "UPDATE_SELECTED_OPTION",
	CHANGE_WIDTH_AND_HEIGHT: "CHANGE_WIDTH_AND_HEIGHT",
	START_TIMER: "START_TIMER",
	RESET_TIMER: "RESET_TIMER"
};

export default actions;



// WEBPACK FOOTER //
// /src/constants/actions.js